import React from 'react';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Button from '../../components/bootstrap/Button';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Label from '../../components/bootstrap/forms/Label';

const Register = () => {
	return (
		<React.Fragment>
			<PageWrapper title='Register'>
				<div className='row align-items-center justify-content-center'>
					<div className='col-xl-6 col-sm-12 left-aside'></div>
					<div className='col-xl-6 col-sm-12 right-aside'>
						<div className='col-xl-6'>
							<img
								src={require('../../assets/img/logo.png')}
								width='50'
								alt='Liiftsocial'
							/>
							<h3 className='greeting-text'>Welcome to Liiftsocial</h3>
							<p className='greeting-subtext'>
								Schedule, Analyse, Publish your content in just few clicks.
							</p>
							<form className='row g-4 login-form'>
								<div className='col-12'>
									<Label htmlFor='register-name'>Name</Label>
									<FormGroup id='register-name' isFloating label='Name'>
										<input type='text' className='form-control' />
									</FormGroup>
								</div>
								<div className='col-12'>
									<Label htmlFor='register-email'>Email</Label>
									<FormGroup id='register-email' isFloating label='Email'>
										<input type='email' className='form-control' />
									</FormGroup>
								</div>
								<div className='col-12'>
									<Label htmlFor='register-password'>Password</Label>
									<FormGroup id='register-password' isFloating label='Password'>
										<input type='password' className='form-control' />
									</FormGroup>
								</div>
								<div className='col-12 mt-5'>
									<Button color='primary' className='w-100 py-3'>
										Register
									</Button>
								</div>
							</form>
							<div className='col-12 mt-4'>
								<div className='d-flex' style={{ justifyContent: 'center' }}>
									<p>Already have an account? </p>
									<a
										href='/login'
										className='forgot-pass-text'
										style={{ marginLeft: '5px' }}>
										Sign in
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</PageWrapper>
		</React.Fragment>
	);
};

export default Register;
